import React from 'react';
import styles from './TinyLoader.module.css';

const TinyLoader = () => {
    return <div className={styles.loader}></div>;
};

export default TinyLoader;
